/** InsCoder 2026-04-01 B + Init swiper for collection optimized recommend **/
function initCollectionOptimizedRecommend() {
  const swiperContainers = document.querySelectorAll('.cust-optimized-recommend__slider');
  
  swiperContainers.forEach(container => {
    // Avoid double initialization
    if (container.classList.contains('swiper-initialized')) return;

    const section = container.closest('.cust-optimized-recommend');
    if (!section) return;

    const prevBtn = section.querySelector('.cust-optimized-recommend__nav-btn--prev');
    const nextBtn = section.querySelector('.cust-optimized-recommend__nav-btn--next');

    new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        750: {
          spaceBetween: 20
        }
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionOptimizedRecommend);
} else {
  initCollectionOptimizedRecommend();
}

// Re-init on Shopify theme editor events if needed
document.addEventListener('shopify:section:load', initCollectionOptimizedRecommend);
/** InsCoder 2026-04-01 E + Init swiper for collection optimized recommend **/
